module.exports = __webpack_public_path__ + "img/rankTitle.737da717.png";